/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

function validateProductForm(btn) {
  let form = btn.closest('form');

  let valid = true;

  if (form.querySelector('.custom-field')) {
    let i = 1;
    form.querySelectorAll('.custom-field').forEach(function (field) {
      let personalized = false;
      if (field.value.length > 0) personalized = true;
      if (field.classList.contains('required') && field.value.length < 1) {
        valid = false;
        field.closest('.field-container').classList.add('error');
      } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
        valid = false;
        field.closest('.field-container').classList.add('error');
      } else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }

      if (personalized) {
        if (form.querySelector('input[name="properties[_personalized_' + i + ']"]') == null) {
          let input = document.createElement("input");
          input.setAttribute('type', 'hidden');
          input.setAttribute('name', 'properties[_personalized_' + i + ']');
          input.setAttribute('value', 'true');
          form.appendChild(input);
        } else {
          form.querySelector('input[name="properties[_personalized_' + i + ']"]').value = 'true';
        }
      }
      i++;
    });
  }

  return valid;
}

/*function validateCheckSpelling(btn) {
  let parent = btn.parentNode;
  let valid = false;

  if (parent.querySelector('input[name="check-spelling"]') != null) {
    if (parent.querySelector('input[name="check-spelling"]').checked) {
      valid = true;
    }
  }

  return valid;
}*/

if (document.querySelector(".Form__Input.custom-field")) {
  document.querySelectorAll(".Form__Input.custom-field").forEach(function (el) {
    el.addEventListener("keyup", (e) => {
      let field = e.target;
      if (field.classList.contains('required') && field.value.length < 1) {
        field.closest('.field-container').classList.add('error');
      } else if (field.classList.contains('required') && field.classList.contains('select') && field.value == '0') {
        field.closest('.field-container').classList.add('error');
      } else {
        field.classList.remove('error');
        field.closest('.field-container').classList.remove('error');
      }
    });
  });

}

if (document.querySelector(".product-form .product-form__add-button")) {
  document.querySelectorAll(".product-form .product-form__add-button").forEach(function (el) {
    el.addEventListener("click", (e) => {
      let valid = validateProductForm(e.target);
      if (!valid) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    });
  });
}

/*
$(document).on('click', 'label[for="check-spelling"]', function (e) {
  let input = $(this).closest('.check-spelling-container').find('input');
  input.checked = !input.checked;
});
$(document).on('click', '.custom-checkbox .checkmark', function (e) {
  let input = e.target.closest('.check-spelling-container').querySelector('input');
  input.checked = !input.checked;
});*/

/*$(function() {
  let h = $('.shopify-section--header').height();
  $('predictive-search-drawer').height(h);
});*/

/*$(document).on('click', '.checkout-button', function (e) {
  let valid = validateCheckSpelling(e.target);
  let error = document.querySelector('.error.error-no-kit-in-cart');

  if (!valid) {
    e.preventDefault();
    e.stopPropagation();
    document.querySelector('.check-spelling-container').classList.add('error');
    return false;
  } else {
    document.querySelector('.check-spelling-container').classList.remove('error');

    let data = null
    let _data = e.target.dataset.cart;

    if(_data) data = JSON.parse(_data);

    if (data && typeof data.attributes['_required_packages_in_cart'] != "undefined" && parseInt(data.attributes['_required_packages_in_cart']) > 0) {
      // required package in cart
      e.preventDefault();
      e.stopPropagation();
      if (error) {
        error.classList.remove('active');
      }
      submitRequiredPackagesDraftOrder($(this));
    } else if (window.required_packages_block_checkout) {
      // required package NOT in cart, block checkout
      if (error) {
        e.preventDefault();
        e.stopPropagation();
        error.classList.add('active');
      }
    }

  }
});*/

// set up a mutation observer to trigger changing cart items prices and images
var observeDOM = (function () {
  var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      var mutationObserver = new MutationObserver(callback)

      mutationObserver.observe(obj, {childList: true, subtree: true})
      return mutationObserver
    } else if (window.addEventListener) {
      obj.addEventListener('DOMNodeInserted', callback, false)
      obj.addEventListener('DOMNodeRemoved', callback, false)
    }
  }
})()

function submitRequiredPackagesDraftOrder(btn) {
  let data = JSON.parse(btn.attr('data-cart'));

  $.ajax({
    url: window.api_base_url + '/api/draft-orders',
    method: 'POST',
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
    data: JSON.stringify(data),
    success(response) {
      if (typeof response.url != "undefined") {
        window.location.href = response.url;
      }
    },
    error(response) {
      console.log(response)
    }
  });
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function getCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseCookie(name) {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

document.addEventListener('DOMContentLoaded', (e) => {
  if (getCookie('required_package_initialized') == null) {
    document.querySelector('body').classList.remove('required-package-initialized');
  }
});


/*
$(document).on('DOMSubtreeModified', '.template-collection .ais-page .ais-hits-container', (e) => {
  if(document.querySelector('.template-collection .ais-page .ais-hits-container .ais-hit-empty')) {
    document.querySelector('.template-collection .ais-page .ais-facets').remove();
    document.querySelector('.template-collection .ais-page .ais-Stats').classList.add('hidden');
    document.querySelector('.template-collection .ais-page .ais-block').style.width = '100%';
  }
});*/

if(document.querySelector('.header__icon-search')) {
  document.querySelector('.header__icon-search').addEventListener('click', (e)=> {
    let target = document.querySelector('#search-drawer');
    target.setAttribute('open','true');
  });
}